var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedinIcon = function SvgLinkedinIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.837 2.16H2.921a1.292 1.292 0 0 0-1.292 1.292v14.916A1.292 1.292 0 0 0 2.92 19.66h14.916a1.291 1.291 0 0 0 1.292-1.292V3.452a1.292 1.292 0 0 0-1.292-1.292ZM6.845 17.068H4.214V8.71h2.63v8.358ZM5.528 7.552a1.51 1.51 0 1 1 1.519-1.509 1.489 1.489 0 0 1-1.52 1.51Zm11.015 9.523h-2.63V12.51c0-1.346-.572-1.762-1.311-1.762-.78 0-1.546.588-1.546 1.796v4.532H8.425V8.717h2.53v1.158h.034c.254-.514 1.144-1.393 2.501-1.393 1.468 0 3.054.871 3.054 3.424l-.001 5.17Z"
  })));
};
export default SvgLinkedinIcon;